import React from 'react';
import { TeamsEditTemplate } from 'themes/application/teams/pages';
import { observer } from 'mobx-react';
import { TeamsEditViewStore } from 'application/teams/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new TeamsEditViewStore(rootStore), 'teamsEditViewStore')
@observer
class TeamsEdit extends React.Component {
    render() {
        return <TeamsEditTemplate {...this.props} />
    }
}

export default TeamsEdit;